import BaseUseCase from "../../base_use_case.js.jsx";

class SaveSubscriberUseCase extends BaseUseCase {

  execute(params, token) {
    let url = `/api/v1/downloadables/downloadables/${params.downloadable}/subscribe`;

    let wrappedParams = this.wrapParams(params, "subscriber");
    wrappedParams.findBySlug = true;
    wrappedParams.recaptchaToken = token;

    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: url,
      data: wrappedParams,
    });
  }
}

const instance = new SaveSubscriberUseCase();
export default instance;
